export default __webpack_public_path__ + "static/media/DS-DIGI.0ef0e224.TTF";